import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus }  from '@fortawesome/free-solid-svg-icons';

import DataTable from '../DataTable';

class NewsAdminPage extends Component {
    columns = [
        {
            header: 'Cím',
            id: 'title',
            cell: row => <NavLink to={`/admin/news/${row.id}`}>{row.title}</NavLink>
        },
        {
            header: 'Létrehozva',
            id: 'creationDate',
            filterable: false,
            cell: row => (
                <span>
                    {new Date(row.creationDate).toLocaleString("hu")}{' '}
                    <small><em>({row.createdByUserName})</em></small>
                </span>
            )
        },
        {
            header: 'Utoljára módosítva',
            id: 'lastModificationDate',
            filterable: false,
            cell: row => {
                if (row.lastModificationDate !== null)
                    return (
                        <span>
                            {new Date(row.lastModificationDate).toLocaleString("hu")}{' '}
                            <small><em>({row.lastModifiedByUserName})</em></small>
                        </span>
                    );
                else return null;
            }
        }
    ];

    render() {
        return (
            <>
                <h1>Hírek</h1>
                <DataTable url='/admin/news' columns={this.columns} onSelectionChange={e => alert(e)} />
                <NavLink className="btn btn-primary" to="/admin/news/create"><FontAwesomeIcon icon={faPlus} /> Új hír</NavLink>
            </>
        );
    }
}

export default NewsAdminPage;
